import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { PipesModule } from "../../../pipes/pipes.module";
import { UsuariosRoutingModule } from "./usuarios-routing.module";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { MaterialModule } from "../../../components/material/material.module";
import { UsuariosComponent } from "./usuarios.component";
import { UsuarioModule } from "../../../forms/usuarios/usuario.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        UsuariosRoutingModule,
        BotonToggleModule,
        MaterialModule,
        UsuarioModule,
    ],
    declarations: [
        UsuariosComponent,
    ],
    providers: [
    ],
    entryComponents: [
    ]
})
export class UsuariosModule { }